<template>
  <div class="col-xs-10 col-sm-10 grid_div" id="grid_right_div">
    <!--<div id="flushBtn"></div>-->
    <div id="contentDiv">
      <div class="head_title">
        <div class="head_title_font">网络课堂</div>
      </div>
      <div class="body_content">
        <!-- 按钮触发模态框 -->
        <button type="button" class="btn btn-default btn_option addBtn" data-toggle="modal" data-target="#myModal" @click="option_flag = 'add'">+新增网络课堂</button>
        <!-- 模态框（Modal） -->
        <div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" data-backdrop='static'>
          <div class="modal-dialog">
            <div class="modal-content modal-content-add">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
                  &times;
                </button>
                <h4 class="modal-title" id="myModalLabel">
                  <!--编辑移动教程-->
                  {{option_flag=="add"?'新增网络课堂':'编辑网络课堂'}}
                </h4>
              </div>
              <div class="modal-body modal-body-add">
                <div class="editVideoDiv" v-if="option_flag == 'edit' && isDeleteVideo == false">
                  <label>历史上传视频：</label>
                  <p class="fileListP">
                    <a @click="openVideoModal(edit_current_video_data.filePath)">{{videoFileName}}</a>
                    <span title="删除" class="glyphicon glyphicon-remove" @click="deleteAttachmentsFile('video', edit_current_video_data.attachmentId)"></span>
                  </p>
                </div>

                <!--上传视频-->
                <uploader v-bind:class="{displayVideoUploadCom: (option_flag == 'edit' && isDeleteVideo == false)}"
                          :options="upload.options" :file-status-text="upload.statusText" class="uploader-example" ref="uploaderVideo">
                  <uploader-unsupport></uploader-unsupport>
                  <uploader-drop>
                    <p>拖拽视频至此处</p>
                    <uploader-btn :attrs="upload.attrs.video">上传视频</uploader-btn>
                  </uploader-drop>
                  <uploader-list></uploader-list>
                </uploader>

                <div role="form" class="classRoom_form">
                  <input v-validate="'required|maxL:80'" data-vv-scope="classRoom" data-vv-as="标题" name="title" type="text" class="form-control" placeholder="标题" v-model="videoTitle">
                  <span class="spanRed">*</span><br>
                  <span class="validateTip">{{ errors.first('classRoom.title') }}</span>

                  <input v-validate="'required|maxL:30'" data-vv-scope="classRoom" data-vv-as="主讲老师姓名" name="teacherName" type="text" class="form-control" placeholder="主讲老师姓名" v-model="videoTeacherName">
                  <span class="spanRed">*</span><br>
                  <span class="validateTip">{{ errors.first('classRoom.teacherName') }}</span>

                  <textarea v-validate="'maxL:300'" data-vv-scope="classRoom" data-vv-as="课程简介" name="videoSummery" class="form-control" placeholder="课程简介" v-model="videoSummery"></textarea>
                  <span class="validateTip">{{ errors.first('classRoom.videoSummery') }}</span>

                </div>

                <div class="editVideoDiv" v-if="option_flag == 'edit'">
                  <label>历史上传附件：</label>
                  <p class="fileListP" v-for="(att, index) in edit_current_file_data" :key="index">
                    <a @click="openFileModal(att.filePath)">{{att.fileName}}</a>
                    <span title="删除" class="glyphicon glyphicon-remove" @click="deleteAttachmentsFile('file', att.id)"></span>
                  </p>
                </div>



                <!--上传文件-->
                <uploader :options="upload.fileOptions" :file-status-text="upload.statusText" class="uploader-example" ref="uploaderFile">
                  <uploader-unsupport></uploader-unsupport>
                  <uploader-drop>
                    <p>拖拽文件至此处</p>
                    <uploader-btn :attrs="upload.attrs.file">上传文件</uploader-btn>
                  </uploader-drop>
                  <uploader-list></uploader-list>
                </uploader>
                <div class="editVideoDiv" v-if="option_flag == 'edit' && isDeleteImage == false">
                  <label>历史上传图片：</label>
                  <p class="fileListP">
                    <a @click="openImageModal(videoThumbSrc)">{{videoThumbName}}</a>
                    <span title="删除" class="glyphicon glyphicon-remove" @click="deleteAttachmentsFile('image', videoThumbId)"></span>
                  </p>
                </div>
                <!--上传图片-->
                <uploader v-bind:class="{displayVideoUploadCom: (option_flag == 'edit' && isDeleteImage == false)}"
                          :options="upload.imageOptions" :file-status-text="upload.statusText" class="uploader-example" ref="uploaderImage">
                  <uploader-unsupport></uploader-unsupport>
                  <uploader-drop>
                    <p>拖拽图片至此处</p>
                    <uploader-btn :attrs="upload.attrs.image">上传图片</uploader-btn>
                  </uploader-drop>
                  <uploader-list></uploader-list>
                </uploader>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-default" @click="saveClassRoom()">保存</button>
                <button type="button" class="btn btn-default" @click="closeClassRoom()">取消</button><!--data-dismiss="modal"-->
              </div>
            </div>
          </div>
        </div>

        <!--视频显示-->
        <div class="modal fade" id="myModal_showVideo" tabindex="-1" role="dialog" aria-labelledby="myModalLabel_showVideo" aria-hidden="true" data-backdrop='static'>
          <div class="modal-dialog modal-dialog-look">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
                  &times;
                </button>
                <h4 class="modal-title" id="myModalLabel_showVideo">
                  视频预览
                </h4>
              </div>
              <div class="modal-body modal-body-look">
                <video class="showVideo video-js" :src="videoSrc" :type="videoType" controls="controls" controlslist="nodownload" autoplay="autoplay" loop="loop" :poster="videoThumbSrc">
                </video>
              </div>
            </div>
          </div>
        </div>

        <!--文档显示-->
        <div class="modal fade" id="myModal_showFile" tabindex="-1" role="dialog" aria-labelledby="myModalLabel_showFile" aria-hidden="true" data-backdrop='static'>
          <div class="modal-dialog modal-dialog-look">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
                  &times;
                </button>
                <h4 class="modal-title" id="myModalLabel_showFile">
                  文档预览
                </h4>
              </div>
              <div class="modal-body modal-body-look">
                <iframe :src="fileSrc" width="100%" height="700px"></iframe>
              </div>
            </div>
          </div>
        </div>

        <!--图片显示-->
        <div class="modal fade" id="myModal_showImage" tabindex="-1" role="dialog" aria-labelledby="myModalLabel_showImage" aria-hidden="true" data-backdrop='static'>
          <div class="modal-dialog modal-dialog-look">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
                  &times;
                </button>
                <h4 class="modal-title" id="myModalLabel_showImage">
                  图片预览
                </h4>
              </div>
              <div class="modal-body modal-body-look">
                <img :src="videoThumbSrc" class="previewImg"/>
              </div>
            </div>
          </div>
        </div>

        <!--数据列表-->
        <div class="content_all">
          <div class="content_one" v-for="(video, index) in videoList" :key="index">
            <div class="classRoom_pic" @click="openVideoModal(video.filePath)">
              <img v-if="video.tpfilePath" :src="resourcesPath + video.tpfilePath"/>
              <img v-else src="../assets/img/back_bg/ht_sp_1.png"/>
            </div>
            <div class="classRoom_rightContent">
              <div class="classRoom_optionBtn">
                <span @click="option_flag = 'edit';editClassRoom(index)"><img src="../assets/img/right/clazz/edit_mouseOver.png"/></span>
                <span @click="deleteClassRoom(video.id)"><img src="../assets/img/right/clazz/delete_mouseOver.png"/></span>
              </div>
              <table class="table classRoom_right">
                <tbody>
                <tr>
                  <td colspan="2"><b>{{video.title}}</b></td>
                </tr>
                <tr>
                  <td class="title_td">主讲教师</td>
                  <td class="content_td">{{video.teacher}} &nbsp; {{video.createTime}}</td>
                </tr>
                <tr>
                  <td class="title_td">课堂资料</td>
                  <td class="content_td">
                    <a v-for="(file, index_f) in video.attachments" :key="index_f" @click="openFileModal(file.filePath)">
                      {{file.fileName}}
                    </a>
                  </td>
                </tr>
                <tr>
                  <td class="title_td">课程简介</td>
                  <td class="content_td" :title="video.summery">{{video.summery | format_summery}}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {schoolAxios} from '../main';

  import {getContentSize} from './mainView';

  export default {
    name: "classRoom",
    data() {
      return {
        option_flag: '',

        videoList: [],

        isUploadVideo: false,
        isDeleteVideo: false,

        isUploadImage: false,
        isDeleteImage:false,

        //上传ID
        attachmentIds: '',
        //上传
        upload: {
          uploaderVideo: null,
          uploaderFile: null,
          uploaderImage: null,
          options: {
            target: this.$store.state.serviceBase + 'upload/chunkUpload.action',
            maxChunkRetries: 3,
            method: 'post',
            headers: {
              'Authorization': this.$store.state.token_type + " " + this.$store.state.access_token
            },
            query: {
              attachmentType: 'mlsp'
            },
            simultaneousUploads: 1,
            testChunks: false,
            chunkSize: 1024*1024,
            singleFile: true,
          },
          fileOptions: {
            target: this.$store.state.serviceBase + 'upload/chunkUpload.action',
            maxChunkRetries: 3,
            method: 'post',
            headers: {
              'Authorization': this.$store.state.token_type + " " + this.$store.state.access_token
            },
            query: {
              attachmentType: 'mlw'
            },
            simultaneousUploads: 1,
            testChunks: false,
            chunkSize: 1024*1024,
          },
          imageOptions: {
            target: this.$store.state.serviceBase + 'upload/chunkUpload.action',
            maxChunkRetries: 3,
            method: 'post',
            headers: {
              'Authorization': this.$store.state.token_type + " " + this.$store.state.access_token
            },
            query: {
              attachmentType: 'mltp'
            },
            simultaneousUploads: 1,
            testChunks: false,
            chunkSize: 1024*1024,
          },
          attrs: {
            file: {
              accept: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/msword,application/pdf'
            },
            image: {
              accept: 'image/*'
            },
            video: {
              accept: 'video/*'
            },
          },
          statusText: {
            success: '成功了',
            error: '出错了',
            uploading: '上传中',
            paused: '暂停中',
            waiting: '等待中',
          },
        },

        //视频
        videoSrc: '',
        videoThumbId:'',
        videoThumbSrc: '',
        videoThumbName: '',
        videoType: 'video/mp4',

        //文档
        fileSrc: '',

        videoFileName: '',
        videoId: '',
        videoTitle: '',
        videoTeacherName: '',
        videoSummery: '',
        resourcesPath:this.$store.state.serviceBase + "resources/",

        edit_current_video_data: {
          attachmentId: '',
          filePath: '',
        },
        edit_current_file_data: [],
      }
    },
    filters: {
      format_summery(value){
        if(value.length>=25){
          value = value.substring(0, 25) + "...";
        }
        return value;
      }
    },
    created: function () {

    },
    mounted: function () {
      let this_ = this;
      this.$nextTick(function () {
        getContentSize();
        this_.loadClassRoomData();

        //绑定加载关闭模态框时的事件
        this_.closeModal();

        //获得上传组件对象
        this_.upload.uploaderVideo = this_.$refs.uploaderVideo.uploader;
        this_.upload.uploaderFile = this_.$refs.uploaderFile.uploader;
        this_.upload.uploaderImage = this_.$refs.uploaderImage.uploader;
        //上传组件绑定事件
        this_.loadUpload();
      })
    },
    methods: {
      /**
       * 加载首页数据
       */
      loadClassRoomData(){
        let this_ = this;
        schoolAxios({
          method: 'get',
          url: 'mobileLearning/findDetailsList',
          params: {}
        }).then(function (videoResp) {
          let videoData = videoResp.data;
          if(videoData.success){
            this_.videoList = videoData.list;
          }
        });
      },


      /**
       * 保存班级资源
       */
      saveClassRoom(){
        let this_ = this;
        this_.$validator.validateAll('classRoom').then(result => {
          if (result) {
            if(!this_.isUploadVideo) {
              "请上传视频文件".showMessage();
              return false;
            }
            if (this_.videoTitle == "") {
              "请输入标题".showMessage();
              return false;
            }
            if (this_.videoTeacherName == "") {
              "请输入主讲老师姓名".showMessage();
              return false;
            }
            let method = '';
            let url = '';
            let params = {};
            if (this_.option_flag == 'add') {
              method = 'post';
              url = 'mobileLearning/add';
              params = {
                attachmentIds: this_.attachmentIds,
                id: this_.videoId,
                title: this_.videoTitle,
                teacher: this_.videoTeacherName,
                summery: this_.videoSummery,
              };
            } else {
              method = 'put';
              url = 'mobileLearning/edit';
              params = {
                attachmentIds: this_.attachmentIds,
                id: this_.videoId,
                title: this_.videoTitle,
                teacher: this_.videoTeacherName,
                summery: this_.videoSummery,
              };
            }
            schoolAxios({
              method: method,
              url: url,
              data: params
            }).then(function (resp) {
              let data = resp.data;
              if (data.success) {
                "保存成功".showMessage();
                $("#myModal").modal('hide');
                this_.loadClassRoomData();
              } else {
                "保存失败".showMessage();
              }
            });
          }
        });
      },

      closeClassRoom(){
        let this_ = this;
        if(this_.option_flag == 'add'){
          $("#myModal").modal('hide');
        }else {
          if(!this_.isUploadVideo){
            "您当前没有上传视频，点击确定可能会造成这条记录的丢失".showConfirm(function () {
              $("#myModal").modal('hide');
              this_.loadClassRoomData();
            });
          }else{
            $("#myModal").modal('hide');
          }
        }
      },

      /**
       * 修改
       */
      editClassRoom(index){
        let this_ = this;
        let my_data = this_.videoList[index];
        //console.info(my_data);

        this_.edit_current_video_data = {
          attachmentId: my_data.attachmentId,
          filePath: my_data.filePath,
        };
        this_.edit_current_file_data = my_data.attachments;

        this_.videoThumbId = my_data.tpattachmentId;
        this_.videoThumbSrc = my_data.tpfilePath;
        this_.videoThumbName = my_data.tpfileName;

        this_.isUploadVideo = true;
        this_.isDeleteVideo = false;


        if(this_.videoThumbId){
          this_.isUploadImage = true;
          this_.isDeleteImage = false;
        }else{
          this_.isUploadImage = false;
          this_.isDeleteImage = true;
        }

        this_.videoFileName = my_data.fileName;
        this_.videoId = my_data.id;
        this_.videoTitle = my_data.title;
        this_.videoTeacherName = my_data.teacher;
        this_.videoSummery = my_data.summery;

        $("#myModal").modal('show');

        //组装附件ID
        this_.splitAttachmentIds(my_data.attachmentId);
        let attachments = my_data.attachments;
        for(let i=0; i<attachments.length; i++){
          this_.splitAttachmentIds(attachments[i].id);
        }
      },

      /**
       * 拼接附件ID
       */
      splitAttachmentIds(attachmentIds){
        let this_ = this;
        if(this_.attachmentIds != ""){
          this_.attachmentIds += ",";
        }
        this_.attachmentIds += attachmentIds;
      },

      deleteAttachmentsFile(deleteFileType, id){
        let this_ = this;
        "确定删除".showConfirm(function () {
          schoolAxios({
            method: 'delete',
            url: 'upload/delete.action',
            params: {
              uploadAttachmentId: id
            }
          }).then(function (resp) {
            let data = resp.data;
            if(data.success){
              "删除成功".showMessage();
              if(deleteFileType == "video"){
                this_.isUploadVideo = false;
                this_.isDeleteVideo = true;
                this_.upload.uploaderVideo.cancel();
              }else if(deleteFileType == "image"){
                this_.isUploadImage = false;
                this_.isDeleteImage = true;
                this_.upload.uploaderImage.cancel();
              }else {
                let index = -1;
                for(let i=0; i<this_.edit_current_file_data.length; i++){
                  if(this_.edit_current_file_data[i].id == id){
                    index = i;
                  }
                }
                if(index >= 0){
                  this_.edit_current_file_data.splice(index, 1);
                }
              }
            }else{
              "删除失败".showMessage();
            }
          })
        })
      },

      /**
       * 删除
       */
      deleteClassRoom(id){
        let this_ = this;
        "确定删除".showConfirm(function () {
          schoolAxios({
            method: 'delete',
            url: 'mobileLearning/delete/'+id,
            params: {}
          }).then(function (resp) {
            let data = resp.data;
            if(data.success){
              "删除成功".showMessage();
              this_.loadClassRoomData();
            }else{
              "删除失败".showMessage();
            }
          });
        });
      },


      /**
       * 打开视频模态框
       */
      openVideoModal(filePath) {
        let this_ = this;
        this_.videoSrc = this_.$store.state.serviceBase + "resources/" + filePath;
        $("#myModal_showVideo").modal("show");
      },
      /**
       * 打开文件模态框
       */
      openFileModal(filePath) {
        let this_ = this;
        let data = filePath.substring(0, 11);
        let fileId = filePath.substring(11, filePath.indexOf('.'));
        this_.fileSrc = this_.$store.state.serviceBase + "resources/" + data + fileId + "_file/" + fileId + ".html";
        $("#myModal_showFile").modal("show");
      },
      /**
       * 打开图片模态框
       */
      openImageModal(filePath) {
        let this_ = this;
        this_.videoThumbSrc = this_.$store.state.serviceBase + "resources/" + filePath;
        $("#myModal_showImage").modal("show");
      },
      /**
       * 关闭模态框监听
       */
      closeModal() {
        let this_ = this;
        $('#myModal_showVideo').on('hide.bs.modal', function () {
          this_.videoSrc = "";
        });

        $("#myModal").on('hide.bs.modal', function () {
          this_.isUploadVideo = false;
          this_.isDeleteVideo = false;

          this_.attachmentIds = "";
          this_.upload.uploaderVideo.cancel();
          this_.upload.uploaderFile.cancel();
          this_.upload.uploaderImage.cancel();

          this_.videoFileName = "";
          this_.videoId = "";
          this_.videoTitle = "";
          this_.videoTeacherName = "";
          this_.videoSummery = "";
          this_.isUploadImage = false;
          this_.isDeleteImage = true;
          setTimeout(function () {
            this_.errors.clear('classRoom');
          });

        });
      },


      /**
       * 上传加载
       */
      loadUpload(){
        let this_ = this;
        /**
         * 视频上传验证处理
         */
        this_.upload.uploaderVideo.on('fileAdded', function (file, event) {
          if(this_.isUploadVideo == true){
            "当前只允许上传一个视频文件".showMessage();
            return false;
          }
          if(file.fileType.indexOf("video") == -1){
            (file.name+"不是所需格式文件，请重新选择正确的格式文件上传").showMessage();
            return false;
          }
        });
        this_.upload.uploaderVideo.on('fileSuccess', function (rootFile, file, message, chunk) {
          console.log("message fileSuccess:"+ message)
          if(message){
            let message_ = JSON.parse(message);
            if(this_.attachmentIds != ""){
              this_.attachmentIds += ",";
            }
            this_.attachmentIds += message_.message;
          }
          this_.isUploadVideo = true;
        });
        this_.upload.uploaderVideo.on('fileComplete', function (rootFile) {
          console.info(rootFile);
        });
        this_.upload.uploaderVideo.on('fileError', function (rootFile, file, message) {
          (file.name+"上传失败").showMessage();
        });
        /**
         * 文件上传验证处理
         */
        this_.upload.uploaderFile.on('fileAdded', function (file, event) {
          if(this_.upload.attrs.file.accept.indexOf(file.fileType)==-1){
            (file.name+"不是所需格式文件，请重新选择正确的格式文件上传").showMessage();
            return false;
          }
        });
        this_.upload.uploaderFile.on('fileSuccess', function (rootFile, file, message, chunk) {
          if(message){
            let message_ = JSON.parse(message);
            if(this_.attachmentIds != ""){
              this_.attachmentIds += ",";
            }
            this_.attachmentIds += message_.message;
          }
        });
        this_.upload.uploaderFile.on('fileComplete', function (rootFile) {
          console.info(rootFile);
        });
        this_.upload.uploaderFile.on('fileError', function (rootFile, file, message) {
          (file.name+"上传失败").showMessage();
        });

        /**
         * 图片上传验证处理
         */
        this_.upload.uploaderImage.on('fileAdded', function (file, event) {
          if(this_.isUploadImage == true){
            "当前只允许上传一个图片文件".showMessage();
            return false;
          }
          if(file.fileType.indexOf("image") == -1){
            (file.name+"不是所需格式文件，请重新选择正确的格式文件上传").showMessage();
            return false;
          }
        });
        this_.upload.uploaderImage.on('fileSuccess', function (rootFile, file, message, chunk) {
          if(message){
            let message_ = JSON.parse(message);
            if(this_.attachmentIds != ""){
              this_.attachmentIds += ",";
            }
            this_.attachmentIds += message_.message;
          }
          this_.isUploadImage = true;
        });
        this_.upload.uploaderImage.on('fileComplete', function (rootFile) {
          console.info(rootFile);
        });
        this_.upload.uploaderImage.on('fileError', function (rootFile, file, message) {
          (file.name+"上传失败").showMessage();
        });
      },
    }
  }
</script>

<style scoped>
  @import '../assets/css/plugins.css';
  @import "../assets/css/publicStyle.css";
  @import "../assets/css/classRoom.css";
</style>



// WEBPACK FOOTER //
// src/components/classRoom.vue